import React from 'react';
import clsx from 'clsx';
import {loadCSS} from 'fg-loadcss';
import {makeStyles, useTheme} from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import {ArrowBackIos, ArrowForwardIos, ExpandLess, ExpandMore} from "@material-ui/icons";
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Select, { SelectChangeEvent } from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import {
    Collapse, Grid, Icon, TextField,
} from "@material-ui/core";
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import Cards from "./Cards";
import CheckOutDialog from "./CheckOutDialog";
import {Cookies} from "react-cookie";
import {DatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import EventIcon from '@material-ui/icons/Event';
import ConfirmInfo from "./ConfirmInfo";
import subDays from "date-fns/subDays";
import {bool} from "prop-types";

const drawerWidth = 400;

export const CartContext = React.createContext();

export const MyContext = React.createContext();

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    appBar: {
        backgroundColor: "rgb(0, 185, 241)",
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        backgroundColor: "rgb(0, 185, 241)",
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    hide: {
        display: 'none',
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
    },
    drawerOpen: {
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerClose: {
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: 'hidden',
        width: theme.spacing(7) + 1,
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9) + 1,
        },
    },
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
    },
    nested: {
        paddingLeft: theme.spacing(2),
    },
}));

function addDays(date, days) {
    let theDay = new Date(date);
    theDay.setDate(theDay.getDate() + parseInt(days));
    return theDay;
}

function getNumberOfDays(start, end) {
    const date1 = start;
    const date2 = end;

    // One day in milliseconds
    const oneDay = 1000 * 60 * 60 * 24;

    // Calculating the time difference between two dates
    const diffInTime = date2 - date1;

    // Calculating the no. of days between two dates
    const diffInDays = Math.round(diffInTime / oneDay);

    return diffInDays;
}

function dateToString(date) {
    if (isValidDate(date)) {
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        return year + "-" + (month < 10 ? "0" : "") + month + "-" + (day < 10 ? "0" : "") + day;
    }
}

function isValidDate(date) {
    return date && Object.prototype.toString.call(date) === "[object Date]" && !isNaN(date);
}

function isNumeric(str) {
    if (typeof str != "string") return false // we only process strings!
    return !isNaN(str) &&
        !isNaN(parseFloat(str))
}


export default function MainPage(props) {
    const cookies = new Cookies();
    const classes = useStyles();
    const theme = useTheme();
    const [open, setOpen] = React.useState(true);
    const [dialog, setDialog] = React.useState(false);
    const [title, setTitle] = React.useState(props.response[0].itemName);
    const [menuIDX, setMenuIDX] = React.useState(0);
    const [itemBlocked, setitemBlocked] = React.useState(false);
    const [cart, setCart] = React.useState(cookies.get('cart') ? cookies.get('cart') : []);
    const [cartNum, setCartNum] = React.useState(cookies.get('cartNum') ? cookies.get('cartNum') : 0);
    const [confirmText, setText] = React.useState("");
    const [confirmBool, setBool] = React.useState(false);
    const [maxduration, setmaxduration] = React.useState(14);
    var yearMin = 0;
    if (props.daterange.maxDate < props.daterange.minDate) yearMin--;
    // var year = new Date().getFullYear();
    // if (new Date(year + "-" + props.daterange.maxDate).getTime() < new Date().getTime()) {
    //     year++;
    // }
    let defultDuration = 2;
    var maxDate = new Date(props.daterange.maxDate);
    var minDate = new Date(props.daterange.minDate);
    if (addDays(new Date(), 2) > maxDate) {
        defultDuration--;
    }


    let blockoutDates = new Array();
    const blockdates = props.blockdate;
    for (let i = 0; i < blockdates.length; i++) {
        blockoutDates[i] = {
            startdate: subDays(new Date(blockdates[i].startDate), 1),
            enddate: new Date(blockdates[i].endDate)
        }
    }


    var today = new Date();
    var tomorrow = addDays(today, defultDuration-1);
    if (new Date().getTime() < minDate) {
        today = new Date(minDate);
        tomorrow = addDays(today, defultDuration-1);
    }

    for (let i = 0; i < blockoutDates.length; i++) {
        if (today  >= blockoutDates[i].startdate && today <= blockoutDates[i].enddate) {
            today = addDays(blockoutDates[i].enddate , 1);
            tomorrow = addDays(today, defultDuration-1);
        }
    }


    const response = props.response;
    let itemblocklist = new Array();
    const itemblockdate = props.itemblockdate;
    for (let i = 0; i < itemblockdate.length; i++) {
        itemblocklist[i] = {
            itemNo: itemblockdate[i].ItemNo,
            startdate: subDays(new Date(itemblockdate[i].startDate), 1),
            enddate: new Date(itemblockdate[i].endDate)
        }
    }


    // initialize block list
    const startblocklist = [];
    let startend = new Date(addDays(today, defultDuration-1));
    for (let i = 0; i < itemblocklist.length; i++){
        if (today >= itemblocklist[i].startdate && today <= itemblocklist[i].enddate) {
            startblocklist.push(itemblocklist[i].itemNo);
        }

        if (itemblocklist[i].startdate >= today &&  itemblocklist[i].startdate <= startend) {
            startblocklist.push(itemblocklist[i].itemNo);
        }
    }
    const [blockedItem, setblockedItem] = React.useState(startblocklist);

    // start date and duration => list of item to be block
    function findblockeditemlist(startdate, duration) {
        let date = new Date(startdate);
        let enddate = new Date(addDays(date, duration-1));
        let newblockitem = [];
        for (let i = 0; i < itemblocklist.length; i++){
            if (date >= itemblocklist[i].startdate && date <= itemblocklist[i].enddate) {
                newblockitem.push(itemblocklist[i].itemNo);
            }

            if (itemblocklist[i].startdate >= date &&  itemblocklist[i].startdate <= enddate) {
                newblockitem.push(itemblocklist[i].itemNo);
            }
        }
        setblockedItem(newblockitem);
    }


    const setMenuItem = (menuIdx) => {
        setMenuIDX(menuIdx);
        // menuIdx is not itemNo
        let menuItemno = props.response[menuIdx].itemNo;
        if (blockedItem.includes(menuItemno)) {
            setitemBlocked(true);
        } else {
            setitemBlocked(false);
        }
    }



    // const [start, setStart] = React.useState(today.setHours(0, 0, 0, 0));
    const [start, setStart] = React.useState(null);
    const [end, setEnd] = React.useState(tomorrow.setHours(0, 0, 0, 0));
    const [duration, setDuration] = React.useState(defultDuration);
    const [durationvalue, setDurationvalue] = React.useState(defultDuration);
    const setStartDate = (date) => {
        console.log("set starting date!!!!! "  + maxDate)

        if (date == maxDate) {
            return
        } else if (addDays(date, duration-1) > maxDate) {
            setStart(date.setHours(0, 0, 0, 0));
            // setDuration(1);
            setdurationMenuItem(1);
            setEnd(addDays(date, 1).setHours(0, 0, 0, 0));
            setCart([]);
            setCartNum(0);
            findblockeditemlist(date, 2);
        } else {
            // check block out date and set duration
            var nearestBlockout = calculateMaxDate(date);
            var nodays = getNumberOfDays(date, nearestBlockout);
            console.log("nearest block out " + nodays + " , " + duration);
            // if (nodays < duration) {
            //     setDuration(nodays);
            // }
            setdurationMenuItem(nodays);


            setStart(date.setHours(0, 0, 0, 0));
            setEnd(addDays(date, duration-1).setHours(0, 0, 0, 0));
            //setPrice(props.prices[duration - 1] * itemNum);
            setCart([]);
            setCartNum(0);
            findblockeditemlist(date, duration);
        }
    }


    function disableSpecific(date){
        // if(hotelCode==="SNOW5294"){
        //     let startdate = new Date('2022-07-02');
        //     let enddate = new Date('2022-08-22');
        //     return date>=startdate && date<=enddate;
        // }
        let ifdisable = false;
        for (let i = 0; i < blockoutDates.length; i++) {
            if (date >= blockoutDates[i].startdate && date <= blockoutDates[i].enddate) {
                ifdisable = true;
            }
        }
        return ifdisable;
    }

    const setEndDate = (date) => {
            setEnd(date.setHours(0, 0, 0, 0));
            // setDuration(du);
            //     setPrice(props.prices[du - 1] * itemNum);
            setCart([]);
            setCartNum(0);
    }

    function calculateMaxDate(startdate){
        // find the most recent blockout date
        let recentblock = null;
        let nonumberdays = 100000000;
        for (let i = 0; i < blockoutDates.length; i++) {
            if (blockoutDates[i].startdate > startdate ){
                if (getNumberOfDays(startdate, blockoutDates[i].startdate) < nonumberdays ) {
                    recentblock = blockoutDates[i].startdate;
                    nonumberdays = getNumberOfDays(startdate, blockoutDates[i].startdate);
                }
            }
        }
        if (recentblock != null){
            return recentblock;
        }
        return maxDate;
    }


    let currentitem = new Array();
    for (let i = 0; i < response[menuIDX].itemType.length; i++) {
        currentitem[i] = {
            type: response[menuIDX].itemType[i],
            prices: response[menuIDX].prices[i],
            images: response[menuIDX].images[i]
        }
    }




    React.useEffect(() => {
        const node = loadCSS(
            'https://use.fontawesome.com/releases/v5.12.0/css/all.css',
            document.querySelector('#font-awesome-css'),
        );

        return () => {
            node.parentNode.removeChild(node);
        };
    }, [itemBlocked]);

    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };

    const menuItems = [];
    for (let i = 1; i <= 14; i++) {
        const dayText = i === 1 ? 'day' : 'days';
        menuItems.push(
            <MenuItem key={i} value={i}>
                {i} {dayText}
            </MenuItem>
        );
    }

    const [durMenuItem, setdurMenuItem] = React.useState(menuItems);

    const setdurationMenuItem = (maxdays) => {
        const menuitems = []
        if (maxdays > 14 )  {
            maxdays = 14;
        }
        console.log("ser dur items" + maxdays);
        if (duration <= 0 || duration > maxdays) {
            setDuration(maxdays);
        }

        for (let i = 1; i <= 14; i++) {
            const dayText = i === 1 ? 'day' : 'days';
            menuitems.push(
                <MenuItem disabled={i>maxdays} key={i} value={i}>
                    {i} {dayText}
                </MenuItem>
            );
        }
        setdurMenuItem(menuitems);
    }

    const handleToggle = () => {
        let temp = open;
        setOpen(!temp);
    };

    const windowUrl = window.location.search;
    const params = new URLSearchParams(windowUrl)
    const hotelCode = params.get('hotelCode');
    //
    // if (start >  maxDate) {
    //     setStart(null);
    // }
    if (hotelCode == "" || hotelCode == null) return <p> We need the hotel code to process your booking. </p>;
    else
        return confirmBool ? <ConfirmInfo text={confirmText}/> : <div className={classes.root}>
            <CssBaseline/>
            <AppBar
                position="fixed"
                className={clsx(classes.appBar, {
                    [classes.appBarShift]: open,
                })}
            >
                <Toolbar>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        onClick={handleDrawerOpen}
                        edge="start"
                        className={clsx(classes.menuButton, {
                            [classes.hide]: open,
                        })}
                    >
                        <ArrowForwardIos/>
                    </IconButton>
                    <Typography variant="h6" noWrap style={{flex: 1}}>
                        {title}
                    </Typography>
                    <IconButton
                        color="inherit"
                        aria-label="open"
                        onClick={() => {
                            setDialog(true)
                        }}
                        edge="end"
                    >
                        <ShoppingCartIcon/>
                        <Typography>{cartNum}</Typography>
                    </IconButton>
                </Toolbar>
            </AppBar>
            <Drawer
                variant="permanent"
                className={clsx(classes.drawer, {
                    [classes.drawerOpen]: open,
                    [classes.drawerClose]: !open,
                })}
                classes={{
                    paper: clsx({
                        [classes.drawerOpen]: open,
                        [classes.drawerClose]: !open,
                    }),
                }}
            >
                <div className={classes.toolbar}>
                    <IconButton onClick={handleDrawerClose}>
                        {theme.direction === 'rtl' ? <ArrowForwardIos/> : <ArrowBackIos/>}
                    </IconButton>
                </div>
                <List>
                    <ListItem button onClick={handleToggle}>
                        <ListItemIcon sx={{overflow: 'visible'}}>
                            <EventIcon
                                style={{minWidth: '30px',}}></EventIcon>
                        </ListItemIcon>
                    </ListItem>
                    <ListItem>
                        <ListItemIcon sx={{overflow: 'visible'}}>
                            <Icon style={{minWidth: '30px',}}></Icon>
                        </ListItemIcon>
                        <ListItemText>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <Grid item xs={12}>
                                    <DatePicker
                                        margin="normal"
                                        variant="inline"
                                        id="date-picker-dialog-start"
                                        label="Start Date"
                                        maxDate={addDays(maxDate, -1)}
                                        minDate={minDate}
                                        disablePast
                                        autoOk={true}
                                        format="dd/MM/yyyy"
                                        value={start}
                                        required={true}
                                        onChange={setStartDate}
                                        shouldDisableDate={disableSpecific}
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date',
                                        }}
                                    />
                                </Grid>
                            </MuiPickersUtilsProvider>
                            <br></br>
                            <Grid item xs={12}>
                                {/*<h5> Duration: {duration}</h5>*/}
                              <InputLabel id="demo-simple-select-helper-label">
                                    Duration
                                </InputLabel>

                                <Select
                                    labelId="demo-simple-select-helper-label"
                                    id="demo-simple-select"
                                    value={duration}
                                    label="Duration"
                                    onChange={(event) => {
                                            let mostrecentBlockDate = null;
                                            let numdaysToBlock = 1000000000;
                                        //     // check the most recent block out date
                                            for (let i = 0 ; i < blockoutDates.length;i++) {
                                                if (blockoutDates[i].startdate > start) {
                                                    if (getNumberOfDays(start, blockoutDates[i].startdate) < numdaysToBlock) {
                                                        mostrecentBlockDate = blockoutDates[i].startdate;
                                                        numdaysToBlock = getNumberOfDays(start, blockoutDates[i].startdate);
                                                    }
                                                }
                                            }
                                            let durationValue = event.target.value;
                                            if (addDays(start, event.target.value) < maxDate  & mostrecentBlockDate != null && addDays(start, event.target.value) > mostrecentBlockDate) {
                                                durationValue = numdaysToBlock;
                                            } else if (addDays(start, event.target.value) > maxDate) {
                                                durationValue = getNumberOfDays(start, maxDate);
                                            }
                                        setDuration(durationValue);
                                        setEnd(new Date(new Date(start).getTime() + (durationValue -1)* 24 * 60 * 60 * 1000));
                                        setCart([]);
                                        setCartNum(0);
                                        findblockeditemlist(start,durationValue);
                                        }
                                    }
                                >
                                    {/*{menuItems}*/}
                                    {durMenuItem}
                                </Select>
                                {/*<TextField*/}
                                {/*    value={duration}*/}
                                {/*    id="duration"*/}
                                {/*    label="Day(s)"*/}
                                {/*    required={true}*/}
                                {/*    inputProps={{type: "text", min: 1}}*/}
                                {/*    onChange={(event) => {*/}
                                {/*        let temp = 1;*/}
                                {/*        if (isNumeric(event.target.value) || event.target.value == "") {*/}
                                {/*            let pre = duration;*/}
                                {/*            setDuration(event.target.value);*/}
                                {/*            temp = event.target.value;*/}
                                {/*            if (Number.parseInt(event.target.value) <= 0) {*/}
                                {/*                setDuration(1);*/}
                                {/*                temp = 1;*/}
                                {/*                // setPrice(props.prices[ 0 ] * itemNum);*/}
                                {/*                setCart([]);*/}
                                {/*                setCartNum(0);*/}
                                {/*            } else if (Number.parseInt(event.target.value) >= 15) {*/}
                                {/*                setDuration(14);*/}
                                {/*                temp = 14;*/}
                                {/*                //setPrice(props.prices[13] * itemNum);*/}
                                {/*                setCart([]);*/}
                                {/*                setCartNum(0);*/}
                                {/*            }*/}
                                {/*            let mostrecentBlockDate = null;*/}
                                {/*            let numdaysToBlock = 1000000000;*/}
                                {/*            // check the most recent block out date*/}
                                {/*            for (let i = 0 ; i < blockoutDates.length;i++) {*/}
                                {/*                if (blockoutDates[i].startdate > start) {*/}
                                {/*                    if (getNumberOfDays(start, blockoutDates[i].startdate) < numdaysToBlock) {*/}
                                {/*                        mostrecentBlockDate = blockoutDates[i].startdate;*/}
                                {/*                        numdaysToBlock = getNumberOfDays(start, blockoutDates[i].startdate);*/}
                                {/*                    }*/}
                                {/*                }*/}
                                {/*            }*/}
                                {/*            if (addDays(start, event.target.value) < maxDate  & mostrecentBlockDate != null && addDays(start, event.target.value) > mostrecentBlockDate) {*/}
                                {/*                setDuration(numdaysToBlock);*/}
                                {/*                setEnd(new Date(new Date(start).getTime() + (Number.parseInt(numdaysToBlock) * 24 * 60 * 60 * 1000)));*/}
                                {/*            } else if (addDays(start, event.target.value) > maxDate) {*/}
                                {/*                console.log(event.target.value);*/}
                                {/*                console.log(addDays(start, event.target.value));*/}
                                {/*                setDuration(getNumberOfDays(start, end));*/}
                                {/*                setEnd(new Date(new Date(start).getTime() + (getNumberOfDays(start, end) * 24 * 60 * 60 * 1000)));*/}
                                {/*            } else if (event.target.value != "") {*/}
                                {/*                setEnd(new Date(new Date(start).getTime() + (Number.parseInt(temp) * 24 * 60 * 60 * 1000)));*/}
                                {/*                // setPrice(props.prices[Number.parseInt(temp)-1] * itemNum);*/}
                                {/*                setCart([]);*/}
                                {/*                setCartNum(0);*/}
                                {/*            }*/}
                                {/*        }*/}
                                {/*    }*/}
                                {/*    }*/}
                                {/*    onBlur={(event) => {*/}
                                {/*        if (isNumeric(event.target.value) && Number.parseInt(event.target.value) > 0 && Number.parseInt(event.target.value) < 15) {*/}
                                {/*            setDuration(Number.parseInt(event.target.value));*/}
                                {/*            setEnd(new Date(new Date(start).getTime() + (Number.parseInt(event.target.value) * 24 * 60 * 60 * 1000)));*/}
                                {/*            // setPrice(props.prices[Number.parseInt(event.target.value)-1] * itemNum);*/}
                                {/*        } else {*/}
                                {/*            let du = getNumberOfDays(start, end);*/}
                                {/*            if (du > 0 && du < 15) {*/}
                                {/*                setDuration(du);*/}
                                {/*                //  setPrice(props.prices[du - 1] * itemNum);*/}
                                {/*            }*/}
                                {/*        }*/}
                                {/*    }}*/}
                                {/*></TextField>*/}
                            </Grid>
                        </ListItemText>
                    </ListItem>
                </List>
                <Divider/>
                <List>
                    {response.map((item, index) => {
                        return (
                            <div key={item.itemNo}>
                                <ListItem button key={item.itemName} onClick={() => {
                                    setTitle(item.itemName);
                                    setMenuItem(index);
                                    handleDrawerClose();
                                }}>
                                    <ListItemIcon sx={{overflow: 'visible'}}> <Icon className={item.icon}
                                                                                    style={{minWidth: '30px',}}></Icon></ListItemIcon>
                                    <ListItemText primary={item.itemName}/>
                                </ListItem>
                            </div>
                        )
                    })}

                </List>
                <Divider/>
            </Drawer>
            <CartContext.Provider value={{
                cart: cart,
                setCart: setCart,
                cartNum: cartNum,
                setCartNum: setCartNum,
                confirmBool: confirmBool,
                setBool: setBool,
                confirmText: confirmText,
                setText: setText
            }}>
                <main style={{width: "100%"}}>
                    <CssBaseline/>
                    <div className={classes.toolbar}>
                    </div>
                    <Grid container spacing={1}>
                        {currentitem.map((item, index) => {
                            return (
                                <Grid key={item.type + index} item xs={12} sm={6} md={4} lg={3}>
                                    <Cards name={item.type} source={item.images}
                                           itemCat={response[menuIDX].itemName}
                                           prices={item.prices} itemNo={response[menuIDX].itemNo}
                                           daterange={props.daterange}
                                           start={start} end={end} max={maxDate} duration={duration} blockitem={itemBlocked} blockoutinfo={blockedItem} validDate={duration>0}/>
                                </Grid>
                            )
                        })}
                    </Grid>
                </main>
            </CartContext.Provider>

            <MyContext.Provider value={{
                confirmBool: confirmBool,
                setBool: setBool,
                confirmText: confirmText,
                setText: setText
            }}>
                {dialog ? <CheckOutDialog hotelCode={hotelCode} open={dialog} setOpen={setDialog} cart={cart}
                                          setCart={setCart} cartNum={cartNum}
                                          setCartNum={setCartNum} discount={response[0].discount}></CheckOutDialog>

                    : <div></div>}

            </MyContext.Provider>

        </div>;
}

